import wixWindow from 'wix-window';

$w.onReady(() => {

 $w("#GraduatDataset1").onReady(() => {

  $w("#Graduatesrepeater").onItemReady(($item, itemData, index) => {
   $item('#Gradualeimage').onClick(() => {
    wixWindow.openLightbox('Graduates', itemData)
   });
  });

 });

});
import wixData from "wix-data"

let debounceTimer;
export function iTitle_keyPress(event, $w) {
 if (debounceTimer) {
        clearTimeout(debounceTimer);
        debounceTimer = undefined;
    }
    debounceTimer = setTimeout(() => {
        filter($w('#title').value);
    }, 200);
}

let lastFilterTitle;
function filter(title) {
 if (lastFilterTitle !== title) {
    $w('#GraduatDataset1').setFilter(wixData.filter().contains('iTitle', title));
    lastFilterTitle = title;
    }
}